import React from "react";
import styled from "styled-components";
import {withI18n} from "react-i18next";
// @ts-ignore
import { CWBModal } from "cwb-react";

class FailedEmailDetailsModal extends React.Component<any, any>{
    render() {
        const {t} = this.props;
        return <StyledModal
            className={'cwb-modal'}
            isOpen={this.props.showModal}
            hideModal={this.props.togglePopover}
        >
            <Wrapper>
                <Title>{t('Invalid email address')}</Title>
                <Text>{t('The following attendees did not receive the Virtual Audition link due to an invalid email address on file.')}</Text>
                <StyledTable>
                    <thead>
                    <tr>
                        <th>{t('Name')}</th>
                        <th>{t('Email')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.failedEmailsList.map((curr: any, ii: number) => (<tr key={ii}>
                        <td>{curr.name}</td>
                        <td>{curr.emails.join(', ')}</td>
                    </tr>))}
                    </tbody>
                </StyledTable>
                <BottomText>{t('Please reach out to these attendees and ask them to update the email address on file.')}</BottomText>
            </Wrapper>
        </StyledModal>
    }
}

const StyledModal = styled(CWBModal)`
    min-width: 600px;
    width: 600px;   
    
    .modal-body{
        text-align: left !important;
    } 
`

const Wrapper = styled.div`
    padding-top: 12px;
    padding-bottom: 20px;
    @media (max-width: 576px) {
        width: 90% !important;
    }
`;

const Title = styled.div`
    font-weight: ${(p) => p.theme["font-weight"]};
    font-size: ${(p) => p.theme["xxl-font-size"]};
    line-height: 27px;
    color: ${(p) => p.theme.formField.color};
`

const Text = styled.div`
    font-size: ${(p) => p.theme["font-size"]};
    line-height: 19px;
    color: #53627C;
    margin-top: 9px;
    margin-bottom: 24px;
`

const StyledTable = styled.table`
    width: 100%;
    th, td {
        font-weight: ${(p) => p.theme["font-weight-600"]};
        font-size: ${(p) => p.theme["s-font-size"]};
        line-height: 19px;
        color: ${(p) => p.theme.grey};
    }
    th {
        background: #F8F8F8;
        box-shadow: inset 0px -1px 0px #E7E7F0;
        border-radius: 3px 3px 0px 0px;
        padding: 7px 0;
        &:first-child {
            padding-left: 16px;
        }
    }
    td {
        font-weight: normal;
        padding: 8px 0;
        &:first-child {
            padding-left: 16px;
            padding-top: 16px;
        }
    }
`

const BottomText = styled.div`
    font-size: ${(p) => p.theme["xs-font-size"]};
    line-height: 16px;
    color: #53627C;
    margin-top: 36px;
    margin-left: 16px;
`

export default withI18n()(FailedEmailDetailsModal);
